import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { AnyInformationResponse } from '@/api-client/models/shared/Contracts'
import { useResultReportNew } from '../useResultReport'
import { computed } from 'vue'
type Props = {
  information: AnyInformationResponse | undefined
}

export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardFilterResult',
  props: {
    information: {}
  },
  setup(__props: any) {

const props = __props
const information = computed(() => props.information)
const { report } = useResultReportNew(information)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("span", null, _toDisplayString(_unref(report)), 1)
  ]))
}
}

})